import { Component, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { MedicalsSubData,RelationData, UserData, MedicalRequestDataContainer, DoctorDetailsData, PriorityData,LanguageData,MedicalRequestDataModel,UserProfileModel,ManadatoryFieldsDataModel} from "../../model/index"
//import { MedicalReportService } from '../../MedicalReport/Service/MedicalReport.Service';
import { MedicalRequestService } from '../../MedicalRequest/Service/MedicalRequest.Service';
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
import { ModalComponent } from "../../shared/modeldialog/index";
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { jsPDF } from "jspdf";
declare var require: any;
declare var MedicalRequestGrid: any;
declare let html2canvas: any;
declare let jspdf: any;

@Component({
    selector: 'MentisSoft-MedicalRequest',
    template: require('../Template/MedicalRequest.template.html'),
    styles: [require('../Template/MedicalRequest.css')],
})


export class MedicalRequestComponent implements AfterViewInit {
@ViewChild("EditRequest") EditRequest: ModalComponent;
@ViewChild("SaveConfirmed") SaveConfirmed: ModalComponent;
@ViewChild("medicalreportPopup") medicalreportPopup: ModalComponent;
@ViewChild("loadingindicator") loadingindicator: ModalComponent;

    today = new Date();
    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };

   
    constructor(@Inject(SecurityService) private _SecurityService: SecurityService, private _titleService: Title, private _MedicalRequestService: MedicalRequestService,//private _medicalReportService: MedicalReportService,
        private router: Router) {
            MedicalRequestGrid = this;
        }
	
    year = new Date();
    appDate: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
    columns: any[] = [];
	 month = ("0" + (this.year.getMonth() + 1)).slice(-2);
    date: string = ("0" + this.year.getDate()).slice(-2) + "/" + this.month + "/" + this.year.getFullYear();
    clickedDate: string;
    pid: any;
    loading = false;
    mandatoryParams: Object = {};
    MedicalRequestDataContainer: MedicalRequestDataContainer[] = [];
    PriorityData: PriorityData[] = [];
    RelationData: RelationData[] = [];
    DoctorData: DoctorDetailsData[] = [];
    LanguageData: LanguageData[] = [];
    dataSource: MedicalRequestDataModel[] = [];
	ReportdataSource: MedicalsSubData[] = [];
    manadatoryFieldsDataModel: ManadatoryFieldsDataModel[] = [];
    MedicalRequestDataModel:MedicalRequestDataModel=new MedicalRequestDataModel;
    UserProfileModel: UserProfileModel = new UserProfileModel();
    medicalResult: MedicalsSubData[] = [];
    medicalsubResult: MedicalsSubData = new MedicalsSubData();
    IsManDoctor: boolean = false;
    IsManRequiredDate: boolean = false;
    ISPriority: boolean = false;
    IsLang: boolean = false;
    ISReqRelation: boolean = false;
    IsReqName: boolean = false;
    IsReqEmail: boolean = false;
    IsReqMobile: boolean = false;
    IsCollectorRelation: boolean = false;
    IsCollectorName: boolean = false;
    IsCollectorEMail: boolean = false;
    IsCollectorMobile: boolean = false;
    IsRemarks: boolean = false;
    IsRelation: boolean = false;	
    IsDoctor: boolean = false;
    IsMobileNoRed: boolean = false;
    IsCollectorRelationRed: boolean = false;
    IsCollMobileNoRed: boolean = false;
    IsReqPriority: boolean = false;	
    IsReqLang: boolean = false;
    IsEmail: boolean = false;
    IsName: boolean = false;
    IsCollectorNameRed: boolean = false;
    IsCollectorEmailRed: boolean = false;
    IsReqRemarks: boolean = false;
    IsValidDate: boolean = true;
    IsReqValidDate: boolean = false;
    IsSaveConfirmed: boolean = false;	
    strREQUEST_NO: string = "";
	IsCollectEmailValidation: boolean = false;
	IsReqEmailValidation: boolean = false;

    ReportDoctorName: string = "";
    PatientId: string = "";
    PatientName : string = "";
    ReportNo : string = "";
    Gender : string = "";
    DateOfBirth : string = "";
    MedicaReportDate: string = "";
    SponsorName: string = "";
    CategoryName: string = "";
    OPIPNO: string = "";
    DeptName: string = "";
    MedicalReport: string = "";
                               

    ngAfterViewInit(): void {
        $('#overlay').hide();  
            this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() + 1 } };//{ date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() + 1 } };
        }

    ngOnInit() {
	this.LoadMedicalRecord(); 
	this.LoadViewReport();
}
   
LoadMedicalRecord() {
    this.loading = true;
    var userInfo: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
    this.pid = this._SecurityService.pid;
    this._MedicalRequestService.GetMedicalRequest(userInfo)
        .subscribe(
            p => {
                if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this.loading = false;
                    this.RelationData = p.RelationDataList;
                    this.DoctorData = p.DoctorDataList;
                    this.PriorityData = p.PriorityDataList;
                    this.LanguageData = p.LanguageDataList;
                    this.dataSource=p.MedicalRequestDataModelList;
                    this.UserProfileModel=p.userprofile;
                    this.manadatoryFieldsDataModel = p.MandatoryFieldList;
                    for (var i = 0; i < p.MandatoryFieldList.length; i++) {
                        this.mandatoryParams[p.MandatoryFieldList[i].FieldName.toUpperCase()] = p.MandatoryFieldList[i].MandatoryFlag;
                    }
                    this.AssignMandatoryFieldList();
                    this.buildGrid();
						
                    this._SecurityService.errorMessage = "";
                }

                else if (!p.sessionExpiry || p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            });
}

AssignMandatoryFieldList() {

    if (this.mandatoryParams["DOCTOR"] == true) { this.IsManDoctor = true; }
    else { this.IsManDoctor = false; }

    if (this.mandatoryParams["REQUIREDBYDATE"] == true) { this.IsManRequiredDate = true; }
    else { this.IsManRequiredDate = false; }
		
    if (this.mandatoryParams["PRIORITY"] == true) { this.ISPriority = true; }
    else { this.ISPriority = false; }

    if (this.mandatoryParams["LANGUAGE"] == true) { this.IsLang = true; }
    else { this.IsLang = false; }

    if (this.mandatoryParams["REQUESTERRELATION"] == true) { this.ISReqRelation = true; }
    else { this.ISReqRelation = false; }

    if (this.mandatoryParams["REQUESTERNAME"] == true) { this.IsReqName = true; }
    else { this.IsReqName = false; }

    if (this.mandatoryParams["REQUESTEREMAIL"] == true) { this.IsReqEmail = true; }
    else { this.IsReqEmail = false; }

    if (this.mandatoryParams["REQUESTERMOBILE"] == true) { this.IsReqMobile = true; }
    else { this.IsReqMobile = false; }

    if (this.mandatoryParams["COLLECTORRELATION"] == true) { this.IsCollectorRelation = true }
    else { this.IsCollectorRelation = false; }

    if (this.mandatoryParams["COLLECTORNAME"] == true) { this.IsCollectorName = true }
    else { this.IsCollectorName = false; }

    if (this.mandatoryParams["COLLECTOREMAIL"] == true) { this.IsCollectorEMail = true }
    else { this.IsCollectorEMail = false; }

    if (this.mandatoryParams["COLLECTORMOBILE"] == true) { this.IsCollectorMobile = true }
    else { this.IsCollectorMobile = false; }

    if (this.mandatoryParams["REMARKS"] == true) { this.IsRemarks = true }
    else { this.IsRemarks = false; }
       
}

public buildGrid() {
    try {
        this.buildColumn();

        var dgrid = jQuery("#grdMedicalRequests").data("kendoGrid");
        if (dgrid) {
            $('#grdMedicalRequests').data().kendoGrid.destroy();
            $('#grdMedicalRequests').empty();
        }
        jQuery('#grdMedicalRequests').kendoGrid({
            editable: false,
            filterable: true,
            pageable: {
                pageSizes: [10, 25, 50, 100]
            },
            scrollable: false,
            sortable: true,
            columns: this.columns,
            dataBinding: this.databinding,               
            dataSource: {
                data: this.dataSource,
                pageSize: this.dataSource != null ? 10 : 0,
            },
        });
        jQuery("#grdMedicalRequests").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
        var gridPage = jQuery("#grdMedicalRequests").data("kendoGrid");
        gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
        var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
        pageSizeDropDownList.bind("change", function (e: any) {
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
        });
        }
    catch (ex) {
        this.handleError(ex);
    }
}

buildColumn(): void {
    this.columns = [
		
         {                
             field: "",
             title: "",
             template: kendo.template("#=this.buildRequesRow(REPORT_NO,REQUEST_NO)#").bind(this)
         },
        {                
            field: "REQUEST_NO",
            title: "Request No",
        },
        {               
            field: "REQUEST_DATE",
            title: "Request Date",
        },
        {                
            field: "REPORT_NO",
            title: "Report No",
        },
        {              
            field: "DOCTOR_NAME",
            title: "Doctor Name",
        },
        {              
            field: "STATUS",
            title: "Status",
        },
        {              
            field: "",
            title: "",
            template: kendo.template("#=this.buildLabReportRow(STATUS,REPORT_NO,REQUEST_NO)#").bind(this)
        }
    ];
}  

 keyPress(event: any) {
       
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

buildRequesRow(REPORT_NO: string,REQUEST_NO:string): string {
    if (REPORT_NO != "") {    
	    var line2="<span class='disableBtn' style='color:blue'><input type='radio' name='options' class='disableBtn'/>EDIT</span >";
		return line2
    }
    else {
        var line2="<span style='color:blue'><input type='radio' name='options'   onclick=MedicalRequestGrid.EditRequestData('" + REQUEST_NO  + "') ></input> EDIT </span >";
        return line2
    }
}

EditRequestData(REQUEST_NO)
{
    localStorage.setItem("EditRequestNo", REQUEST_NO);
    this.EditRequest.open();
}
EditConfrim()
{
    this.strREQUEST_NO=localStorage.getItem("EditRequestNo");
    for (var i = 0; i < this.dataSource.length; i++) {          
        if(this.dataSource[i].REQUEST_NO == this.strREQUEST_NO && this.dataSource[i].STATUS =="NEW" ){
            this.MedicalRequestDataModel.REQUEST_NO = this.dataSource[i].REQUEST_NO;
            this.MedicalRequestDataModel.DOCTOR_CODE = this.dataSource[i].DOCTOR_CODE;
            this.MedicalRequestDataModel.REQUIREDBY_DATE = this.dataSource[i].REQUIREDBY_DATE;
			this.appDate=this.dataSource[i].REQUIREDBY_DATE;
            this.MedicalRequestDataModel.PRIORITY = this.dataSource[i].PRIORITY;
            this.MedicalRequestDataModel.LANGUAGE_CODE = this.dataSource[i].LANGUAGE_CODE;
            this.MedicalRequestDataModel.REQUESTOR_RELATION = this.dataSource[i].REQUESTOR_RELATION;
            this.MedicalRequestDataModel.REQUESTOR_NAME = this.dataSource[i].REQUESTOR_NAME;
            this.MedicalRequestDataModel.REQUESTOR_EMAIL = this.dataSource[i].REQUESTOR_EMAIL;
            this.MedicalRequestDataModel.REQUESTOR_MOBILENO = this.dataSource[i].REQUESTOR_MOBILENO;
            this.MedicalRequestDataModel.COLLECTOR_RELATION = this.dataSource[i].COLLECTOR_RELATION;
            this.MedicalRequestDataModel.COLLECTOR_NAME = this.dataSource[i].COLLECTOR_NAME;
            this.MedicalRequestDataModel.COLLECTOR_EMAIL =this.dataSource[i].COLLECTOR_EMAIL;
            this.MedicalRequestDataModel.COLLECTOR_MOBILE_NO = this.dataSource[i].COLLECTOR_MOBILE_NO;
            this.MedicalRequestDataModel.REMARKS = this.dataSource[i].REMARKS;
        }
    }
}
buildLabReportRow(STATUS: string,REPORT_NO:string,REQUEST_NO:string): string {
    if (REPORT_NO != "") { //STATUS != "NEW" && STATUS != "") {
        var line1 = "<a class='small_btn def_btn view_resultbtn' onclick=MedicalRequestGrid.ViewReport('" + REPORT_NO  + "')> <i class='fa fa-file-text' aria- hidden='true' > </i > Report </a>  </span > </div>";

        return line1;
    }
    else {
	 var line1 = "<a class='small_btn def_btn disableBtn  view_resultbtn'>  <i class='fa fa-file-text' aria- hidden='true' > </i >  Report </a> </span > </div> ";

        return line1
    }
}

databinding(e: any) {
    try {
        var grid = jQuery("#grdMedicalRequests").data("kendoGrid");
        var totalCount = grid.dataSource.total();
        var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
        var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
        var pagerds = new kendo.data.DataSource({
            data: pageSizes
        });
        pagerdropdownBox.setDataSource(pagerds);
    }
    catch (e) {
    }
}
	

SaveMedicalRequest()
{
  if (this.MedicalRequestDataModel.REQUESTOR_EMAIL != null && this.MedicalRequestDataModel.REQUESTOR_EMAIL != "" && this.MedicalRequestDataModel.REQUESTOR_EMAIL != "") {
            if (this.MedicalRequestDataModel.REQUESTOR_EMAIL.indexOf("@") <= 0 || (this.MedicalRequestDataModel.REQUESTOR_EMAIL.indexOf(".") <= 0))
            {
                this.IsReqEmailValidation = true;
            }
            else {
                this.IsReqEmailValidation = false;
            }
        }
        else {
            this.IsReqEmailValidation = false;
        }
		  if (this.MedicalRequestDataModel.COLLECTOR_EMAIL != null && this.MedicalRequestDataModel.COLLECTOR_EMAIL != "" && this.MedicalRequestDataModel.COLLECTOR_EMAIL != "") {
            if (this.MedicalRequestDataModel.COLLECTOR_EMAIL.indexOf("@") <= 0 || (this.MedicalRequestDataModel.COLLECTOR_EMAIL.indexOf(".") <= 0))
            {
                this.IsCollectEmailValidation = true;
            }
            else {
                this.IsCollectEmailValidation = false;
            }
        }
        else {
            this.IsCollectEmailValidation = false;
        }
    this.ValidateDoctor();
    this.ValidateReqRelation();
    this.ValidateReqMobileNo();
    this.ValidateCollectorRelation();
    this.ValidateCollectorMobileNo();
    this.ValidateIsReqValidDate();
    this.ValidateIsReqRemarks();
    this.ValidateCollectorMobileNo();	
    this.ValidateCollectorEmail();
    this.ValidateCollectorName();
    this.ValidateReqEmail();
    this.ValidateReqName();
    this.ValidateLanguage();
    this.ValidatePriority(); 
	if (this.MedicalRequestDataModel.REQUIREDBY_DATE == undefined || this.MedicalRequestDataModel.REQUIREDBY_DATE == "" ||this.MedicalRequestDataModel.REQUIREDBY_DATE == "null") {
            this.MedicalRequestDataModel.REQUIREDBY_DATE = this.date;
        }
    if (this.IsDoctor == false && this.IsRelation == false  && this.IsReqEmailValidation == false && this.IsCollectEmailValidation == false && this.IsReqPriority == false && this.IsReqLang == false && this.IsName == false && this.IsEmail == false && this.IsCollectorNameRed == false && this.IsCollectorEmailRed == false && this.IsReqRemarks== false && this.IsMobileNoRed == false && this.IsCollectorRelationRed == false && this.IsReqValidDate == false && this.IsCollMobileNoRed == false && this.IsValidDate == true) {
        this._MedicalRequestService.SaveMedicalRequestDetails(this.MedicalRequestDataModel)
            .subscribe(
            p => {
                this.loading = true;
                if (p == "Success") {
                    this.IsSaveConfirmed= true;
                    this.SaveConfirmed.open();
                    this.clearValues();
                    this.LoadMedicalRecord(); 
                    this.loading = false;
                }
                else {
                    this.IsSaveConfirmed =false;
                    this.SaveConfirmed.open();
                    //this.RegistrationPopup.open();
                    this.loading = false;
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            }
            );
    }
}

ValidateDoctor() {        
    if (this.IsManDoctor == true){
        if (this.MedicalRequestDataModel.DOCTOR_CODE== "null" || this.MedicalRequestDataModel.DOCTOR_CODE == "" || this.MedicalRequestDataModel.DOCTOR_CODE == undefined) {
            this.IsDoctor = true;
        }
        else {
            this.IsDoctor = false;
        }
    }
}

ValidatePriority() { 
    if (this.ISPriority == true){       
        if (this.MedicalRequestDataModel.PRIORITY== "null" || this.MedicalRequestDataModel.PRIORITY == "" || this.MedicalRequestDataModel.PRIORITY == undefined) {
            this.IsReqPriority = true;
        }
        else {
            this.IsReqPriority = false;
        }
    }
}

ValidateLanguage() { 
    if (this.IsLang == true){       
        if (this.MedicalRequestDataModel.LANGUAGE_CODE== "null" || this.MedicalRequestDataModel.LANGUAGE_CODE == "" || this.MedicalRequestDataModel.LANGUAGE_CODE == undefined) {
            this.IsReqLang = true;
        }
        else {
            this.IsReqLang = false;
        }}
}

ValidateReqRelation() { 
    if (this.ISReqRelation == true){       
        if (this.MedicalRequestDataModel.REQUESTOR_RELATION== "null" || this.MedicalRequestDataModel.REQUESTOR_RELATION == "" || this.MedicalRequestDataModel.REQUESTOR_RELATION == undefined) {
            this.IsRelation = true;
        }
        else {
            this.IsRelation = false;
        }}
}

ValidateReqName() {
    if (this.IsReqName == true){        
        if (this.MedicalRequestDataModel.REQUESTOR_NAME== "null" || this.MedicalRequestDataModel.REQUESTOR_NAME == "" || this.MedicalRequestDataModel.REQUESTOR_NAME == undefined) {
            this.IsName = true;
        }
        else {
            this.IsName = false;
        }
    }
}

ValidateReqEmail() { 
    if (this.IsReqEmail == true){       
        if (this.MedicalRequestDataModel.REQUESTOR_EMAIL== "null" || this.MedicalRequestDataModel.REQUESTOR_EMAIL == "" || this.MedicalRequestDataModel.REQUESTOR_EMAIL == undefined) {
            this.IsEmail = true;
        }
        else {
            this.IsEmail = false;
        }}
}
ValidateReqMobileNo() {
    if (this.IsReqMobile == true){        
        if (this.MedicalRequestDataModel.REQUESTOR_MOBILENO== "null" || this.MedicalRequestDataModel.REQUESTOR_MOBILENO == "" || this.MedicalRequestDataModel.REQUESTOR_MOBILENO == undefined) {
            this.IsMobileNoRed = true;
        }
        else {
            this.IsMobileNoRed = false;
        }
    }
}
ValidateCollectorRelation() { 
    if (this.IsCollectorRelation == true){       
        if (this.MedicalRequestDataModel.COLLECTOR_RELATION== "null" || this.MedicalRequestDataModel.COLLECTOR_RELATION == "" || this.MedicalRequestDataModel.COLLECTOR_RELATION == undefined) {
            this.IsCollectorRelationRed = true;
        }
        else {
            this.IsCollectorRelationRed = false;
        }
    }
}

ValidateCollectorName() {  
    if (this.IsCollectorName == true){      
        if (this.MedicalRequestDataModel.COLLECTOR_NAME== "null" || this.MedicalRequestDataModel.COLLECTOR_NAME == "" || this.MedicalRequestDataModel.COLLECTOR_NAME == undefined) {
            this.IsCollectorNameRed = true;
        }
        else {
            this.IsCollectorNameRed = false;
        }
    }
}	
	
ValidateCollectorEmail() {  
    if (this.IsCollectorEMail == true){      
        if (this.MedicalRequestDataModel.COLLECTOR_EMAIL== "null" || this.MedicalRequestDataModel.COLLECTOR_EMAIL == "" || this.MedicalRequestDataModel.COLLECTOR_EMAIL == undefined) {
            this.IsCollectorEmailRed = true;
        }
        else {
            this.IsCollectorEmailRed = false;
        }
    }
}

ValidateCollectorMobileNo() {  
    if (this.IsCollectorMobile == true){      
        if (this.MedicalRequestDataModel.COLLECTOR_MOBILE_NO== "null" || this.MedicalRequestDataModel.COLLECTOR_MOBILE_NO == "" || this.MedicalRequestDataModel.COLLECTOR_MOBILE_NO == undefined) {
            this.IsCollMobileNoRed = true;
        }
        else {
            this.IsCollMobileNoRed = false;
        }
    }
}

ValidateIsReqValidDate() {  
    if (this.IsManRequiredDate == true){      
        if (this.MedicalRequestDataModel.REQUIREDBY_DATE== "null" || this.MedicalRequestDataModel.REQUIREDBY_DATE == "" || this.MedicalRequestDataModel.REQUIREDBY_DATE == undefined) {
            this.IsReqValidDate = true;
        }
        else {
            this.IsReqValidDate = false;
        }
    }
}

ValidateIsReqRemarks() {  
    if (this.IsRemarks == true)
    {      
        if (this.MedicalRequestDataModel.REMARKS== "null" || this.MedicalRequestDataModel.REMARKS == "" || this.MedicalRequestDataModel.REMARKS == undefined) {
            this.IsReqRemarks = true;
        }
        else {
            this.IsReqRemarks = false;
        }
    }
}

/*onDateChanged(event: IMyDateModel) {
    if (event != undefined) {
        var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
        if (dt < this.today && !(dt.toDateString() == this.today.toDateString())) {
            this.IsValidDate = false;
        }
        else if (dt > this.today || dt.toDateString() == this.today.toDateString()) {
            this.IsValidDate = true;
        }
        this.MedicalRequestDataModel.REQUIREDBY_DATE = event.formatted;
        this.MedicalRequestDataModel.REQUIREDBY_DATE = this.MedicalRequestDataModel.REQUIREDBY_DATE.replace(".", "/");
    }
}*/
onDateChanged(event: IMyDateModel) {
        if (event != undefined) {
            if (event.formatted != null && event.formatted != undefined && event.formatted != "") {
                
                    var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
                  //  this.activebutton = dt.getDay();
                
               // if (this.activebutton == 0)
                  //  this.activebutton = 7;
                this.MedicalRequestDataModel.REQUIREDBY_DATE= event.formatted.toString();
                this.MedicalRequestDataModel.REQUIREDBY_DATE = this.MedicalRequestDataModel.REQUIREDBY_DATE.replace(".", "/");
                this.date = this.MedicalRequestDataModel.REQUIREDBY_DATE;
                //this.appDate1 = { date: { year: event.date.year, month: event.date.month + 1, day: event.date.day } };
            }
            else {
                var d = new Date();
                this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
                //this.appDate1 = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
               // this.activebutton = d.getDay();
                this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
                this.MedicalRequestDataModel.REQUIREDBY_DATE = this.clickedDate;
                this.date = this.MedicalRequestDataModel.REQUIREDBY_DATE;
            }        
        }
       // this.activebutton1 = this.activebutton;
       // this.LoadFilterReports();
    }

onRelationchange(event) {
    this.MedicalRequestDataModel.REQUESTOR_NAME="";
    this.MedicalRequestDataModel.REQUESTOR_EMAIL="";
    this.MedicalRequestDataModel.REQUESTOR_MOBILENO="";
    if (this.RelationData != null) {
        for (var i = 0; i < this.RelationData.length; i++) {
            if (this.RelationData[i].RelationName ==  "PATIENT" && this.RelationData[i].RelationCode == event ) {
                this.MedicalRequestDataModel.REQUESTOR_NAME=this.UserProfileModel.PatienName;
                this.MedicalRequestDataModel.REQUESTOR_EMAIL=this.UserProfileModel.Email;
                this.MedicalRequestDataModel.REQUESTOR_MOBILENO=this.UserProfileModel.mobile;
            }
        }
    }
     
}
onCollectorRelationhange(event) {
    this.MedicalRequestDataModel.COLLECTOR_NAME="";
    this.MedicalRequestDataModel.COLLECTOR_EMAIL="";
    this.MedicalRequestDataModel.COLLECTOR_MOBILE_NO="";
    if (this.RelationData != null) {
        for (var i = 0; i < this.RelationData.length; i++) {
            if (this.RelationData[i].RelationName ==  "PATIENT" && this.RelationData[i].RelationCode == event ) {
                this.MedicalRequestDataModel.COLLECTOR_NAME=this.UserProfileModel.PatienName;
                this.MedicalRequestDataModel.COLLECTOR_EMAIL=this.UserProfileModel.Email;
                this.MedicalRequestDataModel.COLLECTOR_MOBILE_NO=this.UserProfileModel.mobile;
            }
        }
    }
      
}
clearValues() {
    this.MedicalRequestDataModel.DOCTOR_CODE = "";
    this.MedicalRequestDataModel.REQUIREDBY_DATE = "";
    this.MedicalRequestDataModel.PRIORITY = "";
    this.MedicalRequestDataModel.LANGUAGE_CODE = "";
    this.MedicalRequestDataModel.REQUESTOR_RELATION = "";
    this.MedicalRequestDataModel.REQUESTOR_NAME = "";
    this.MedicalRequestDataModel.REQUESTOR_EMAIL ="";
    this.MedicalRequestDataModel.REQUESTOR_MOBILENO ="";
    this.MedicalRequestDataModel.COLLECTOR_RELATION ="";
    this.MedicalRequestDataModel.COLLECTOR_NAME ="";
    this.MedicalRequestDataModel.COLLECTOR_EMAIL ="";
    this.MedicalRequestDataModel.COLLECTOR_MOBILE_NO ="";
    this.MedicalRequestDataModel.REMARKS ="";
	this.MedicalRequestDataModel.REQUEST_NO = "";
}


LoadViewReport() {
    this.loading = true;
    var userInfo: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);


    userInfo.pid = this._SecurityService.pid;
    this._MedicalRequestService.getMedicalResults(userInfo)
        .subscribe(
            p =>
            {
                if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired")
                {
                    this._SecurityService.errorMessage = "";
                    this.loading = false;
                    this.ReportdataSource = p.MedicalsSubData;                  
                }

                else if (!p.sessionExpiry || p.SessionTimeout == "Session Expired")
                {
                    this.loading = false;
                    window.document.getElementById("closeBtn").click();
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            });
    this.loading = false;
}
ViewReport(ReportNo) {
for (var i = 0; i < this.ReportdataSource.length; i++) {
                if (this.ReportdataSource[i].REPORT_NO == ReportNo) {
						 this.ReportDoctorName = this.ReportdataSource[i].DoctorName;
                        this.PatientId = this.ReportdataSource[i].PATIENT_ID;
                        this.PatientName = this.ReportdataSource[i].PatientName;
                        this.ReportNo = this.ReportdataSource[i].REPORT_NO;
                        this.Gender = this.ReportdataSource[i].Gender;
                        this.DateOfBirth = this.ReportdataSource[i].DateOfBirth;
                        this.MedicaReportDate = this.ReportdataSource[i].REPORT_DATE;
                        this.SponsorName = this.ReportdataSource[i].SponsorName;
                        this.CategoryName = this.ReportdataSource[i].CATEGORYNAME;
                        this.OPIPNO = this.ReportdataSource[i].OPORIPNo;
                        this.DeptName = this.ReportdataSource[i].DeptName;
                        this.MedicalReport = this.ReportdataSource[i].MEDICAL_REPORT;
                               
                        this.medicalreportPopup.open();
				}
				}
    
}
 labResultPdf123(): void {
        const doc = new jsPDF('p', 'pt', 'a4');
        var downname = 'MedicalReport_' + new Date().getDate() + new Date().getMonth() + new Date().getFullYear() + new Date().getHours() + new Date().getMinutes() + new Date().getMilliseconds() + '.pdf';
        doc.html(document.getElementById("Html5Pdf1"), {
            callback: function (doc) {
                doc.save(downname);
            }
        })
    }
private handleError(error: any) {
    console.log("error : " + error);
}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/MedicalRequest/Component/MedicalRequest.Component.ts